import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const BrandContext = createContext(null);

export function BrandProvider({ children }) {
    const [brand, setBrand] = useState({
        site_name: "Meridian Finance",
        domain: "",
        email: "",
        support_email: "",
        phone: "",
        tagline: "",
    });

    useEffect(() => {
        api.get("/config").then((r) => setBrand(r.data)).catch(() => {});
    }, []);

    // Keep the browser tab title in sync with the live brand (from /api/config).
    useEffect(() => {
        if (brand?.site_name) document.title = brand.site_name;
    }, [brand?.site_name]);

    return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand() {
    return useContext(BrandContext);
}
